<template>
    <b-form-group :class="{'has-error': error}">
        <slot name="label" :label="label" :input-name="name">
            <label :for="name">{{ label }}</label>
        </slot>
        <date-picker
            autocomplete="off"
            autocorrect="false"
            :config="computedDateOptions"
            @dp-change="dateChanged"
            :id="name"
            :name="name"
            :placeholder="placeholder"
            v-model="date"
        ></date-picker>
        <div
            class="help-block"
            v-if="error"
            v-text="error"
        ></div>
    </b-form-group>
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
    name: "DateField",

    components: {
        datePicker,
    },

    props: {
        dateOptions: {
            default: () => ({
                format: 'DD/MM/YYYY',
                useCurrent: false,
                showClear: true,
                sideBySide: true,
            }),
            required: false,
            type: Object
        },
        error: {
            default: null,
            required: false,
            type: String,
        },
        label: {
            default: 'Date',
            required: false,
            type: String,
        },
        name: {
            default: `date`,
            required: false,
            type: String,
        },
        placeholder: {
            default: 'Select a date',
            required: false,
            type: String,
        },
        value: {
            default: '',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            date: this.value,
        }
    },

    computed: {
        computedDateOptions() {
            let computedDateOptions = {...this.dateOptions};

            //Set max date if passed in as a date option. In most use cases we will probably want to pass in a string, as when using
            //This component in a .ctp file, we will not be able to pass in a moment object as required for the underlying component.
            //When we come to use this with more JS files, this could become a problem as the below code will obviously break things
            //If we pass in a moment object. Therefore:
            //TODO also check that if there is a maxDate set, that it is not an instance of a moment object.
            if (Object.hasOwnProperty.call(computedDateOptions, 'maxDate')) {
                computedDateOptions.maxDate = moment(computedDateOptions.maxDate, 'DD-MM-YYYY HH:mm:ss');
            }
            //READ ABOVE INFO ON MAXDATE. SAME APPLIES FOR MINDATE.
            if (Object.hasOwnProperty.call(computedDateOptions, 'minDate')) {
                computedDateOptions.minDate = computedDateOptions.minDate === 'now'
                    ? moment()
                    : moment(computedDateOptions.minDate, 'DD-MM-YYYY HH:mm:ss');
            }

            return computedDateOptions;
        },
    },

    methods: {
        dateChanged(event) {
            this.$emit(`input`, event.target.value);
        },
    },

    watch: {
        value(newValue) {
            this.date = newValue;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/DateField.vue